(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-addon-recommendations"] && !Shopify.designMode) return;
  try {
    if (!window.addonRecommendationsWheelInit) {
    window.addonRecommendationsWheelInit = true

    document.addEventListener(
      'wheel',
      (event) => {
        const list = event.target.closest('.product-addon-recommendations__list')
        if (!list) return
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return
        event.preventDefault()
        window.scrollBy(0, event.deltaY)
      },
      { passive: false }
    )
  }

  if (!window.cartAddonRecommendationsUpdateInit && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    window.cartAddonRecommendationsUpdateInit = true

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const addedProductId = event && event.cartData && event.cartData.product_id
      if (!addedProductId) return

      const card = document.querySelector('.cart-addon-recommendations .addon-card[data-product-id="' + addedProductId + '"]')
      if (!card) return
      card.remove()

      const block = document.querySelector('.cart-addon-recommendations')
      if (block && !block.querySelector('.addon-card')) {
        block.remove()
      }
    })
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-addon-recommendations"] && !Shopify.designMode) return;
  try {
    if (!window.addonRecommendationsWheelInit) {
    window.addonRecommendationsWheelInit = true

    document.addEventListener(
      'wheel',
      (event) => {
        const list = event.target.closest('.product-addon-recommendations__list')
        if (!list) return
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return
        event.preventDefault()
        window.scrollBy(0, event.deltaY)
      },
      { passive: false }
    )
  }
  } catch(e) { console.error(e); }
})();

})();
